<template lang="pug">
  .b-base-input
    ._label(v-if="labelOuter && label") {{ label }}
      template(v-if="unit") , {{ unit }}
    TheMask._field(
      type="tel"
      :placeholder="labelOuter ? '' : label"
      :class="{ error: !!error }"
      :value="value"
      :disabled="disabled"
      :name="name"
      :autocomplete="autocomplete"
      v-on="inputListeners"
      :mask="['+7(###)###-##-##']"
      ref="input"
      :masked="true"
    )
    ._unit(v-if="unit && !labelOuter") {{ unit }}
    ._error-text(v-if="error") {{ error }}
</template>

<script>
import { TheMask } from 'vue-the-mask';

export default {
  name: 'BasePhoneInput',
  props: {
    value: [String, Number],
    label: String,
    error: String,
    disabled: Boolean,
    name: String,
    autocomplete: String,
    unit: String,
    // подпись над полем вместо плейсхолдера — как у BaseInput; BaseField
    // отдаёт этот проп всем типам полей формы
    labelOuter: Boolean,
  },
  components: { TheMask },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: (e) => { this.$emit('input', e === '+7(8' ? '+7(' : e); },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.base-input {
  position: relative;

  // те же значения, что у одноимённой подписи BaseInput: поля формы должны
  // выглядеть одинаково независимо от типа
  &__label {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #92A0B0;
    margin-bottom: 8px;
  }

  &__field {
    font-size: 13px;
    height: 39px;
    padding: 0 16px;
    border-radius: 6px;
    background-color: var(--color-super-light);
    color: var(--color-dark-gray);
    outline: none;
    font-weight: 500;
    box-sizing: border-box;
    display: block;
    width: 100%;
    border: 1px solid transparent;

    &[disabled] {
      color: var(--color-middle-gray);
    }

    &::placeholder {
      opacity: 1;
      font-size: 13px;
      color: var(--color-middle-gray);
      font-weight: 500;
    }

    &.error {
      border: 1px solid!important;
      color: var(--color-red)!important;
      margin-bottom: 4px!important;
    }
  }

  &__unit {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 13px;
    color: var(--color-middle-gray);
  }

  &__error-text {
    max-width: 286px;
    text-align: left;
    color: var(--color-red)!important;
    letter-spacing: .01em;
    font-weight: 500;
    line-height: 13px;
    font-size: 10px;
    padding: 0 16px;
  }
}
</style>
